// Mock data for ODDA Corp. site
export const assets = {
  // Brand logos
  logoWhite:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_odda-refined-space/artifacts/fjszxsq2_Odda%20Corp%20Logo%20NEW%20White.webp",
  logoBlack:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_odda-refined-space/artifacts/0f1cdrmg_Odda%20Corp%20Logo%20NEW%20White%20%26%20Black.webp",
  // Cinematic video assets (self-hosted, audio stripped)
  welcomeVideo: "/videos/welcome.mp4",
  filmVideo: "/videos/film.mp4",
  // Poster fallbacks
  welcomePoster:
    "https://images.unsplash.com/photo-1784559888124-602bb84cc3c7?auto=format&fit=crop&w=2400&q=80",
  heroVisual:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_odda-refined-space/artifacts/im80lxu7_project-03.jpeg",
  project01:
    "https://images.unsplash.com/photo-1625390711106-3728815ebcd9?auto=format&fit=crop&w=1600&q=85",
  project03:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_odda-refined-space/artifacts/im80lxu7_project-03.jpeg",
  project04:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_odda-refined-space/artifacts/d8dp7bcx_project-04.jpeg",
  filmPoster:
    "https://images.unsplash.com/photo-1783029779867-8974a66c24bc?auto=format&fit=crop&w=2400&q=85",
};

export const navItems = [
  { label: "Studio", href: "#studio" },
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Film", href: "#film" },
  { label: "Contact", href: "#contact" },
];

export const projects = [
  {
    id: 1,
    label: "Residential · 01",
    title: "Courtyard Residence",
    image:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_odda-refined-space/artifacts/p57ne25z_image.webp",
    alt: "ODDA courtyard residence rendering",
    size: "large",
  },
  {
    id: 2,
    label: "Residential · 02",
    title: "Modern Residence",
    image: assets.project03,
    alt: "ODDA modern residence with wood-slat facade rendering",
    size: "small",
  },
  {
    id: 3,
    label: "Residential · 03",
    title: "Urban House",
    image: assets.project04,
    alt: "ODDA urban townhouse rendering",
    size: "small",
  },
];

export const services = [
  { num: "01 / 04", title: "Architectural Design", copy: "Intentional architectural concepts for homes and spaces." },
  { num: "02 / 04", title: "Custom Home Design", copy: "Custom homes shaped around your vision and lifestyle." },
  { num: "03 / 04", title: "Renovation Design", copy: "Thoughtful addition and renovation plans for existing properties." },
  { num: "04 / 04", title: "Construction Development", copy: "Development and construction planning from concept to reality." },
];

export const testimonials = [
  {
    quote:
      "Kwesi at NK Design Group executed the design of my dream home efficiently and professionally. I recommend their services to anyone looking for the best!",
    author: "Afua Agyeman",
  },
  {
    quote:
      "Kwesi was professional and easy to work with. He provided guidance throughout the duration of the project and has been available for all follow-up questions.",
    author: "Khurram",
  },
  {
    quote:
      "Every detail was considered. The result is quiet, sculptural, and unmistakably intentional — a home that keeps revealing itself.",
    author: "M. Reyes",
  },
];

export const contactInfo = {
  email: "kaddo@oddacorp.com",
  location: "Toronto · Canada",
  phone: "+1 (647) 607 · 8344",
  hours: "Mon — Fri · 9:00 – 18:00 EST",
  instagram: "https://www.instagram.com/oddacorp",
};
